import { useEffect, useState } from 'react';
import { laboratoryClient } from '../../clients/laboratoryClient';
export const useConv0002Variant = () => {
  const [conv0002Variant, setConv0002Variant] = useState(null);
  useEffect(() => {
    laboratoryClient.resolve(treatments => {
      var _treatments$conv;
      const group = (_treatments$conv = treatments['conv-0002']) === null || _treatments$conv === void 0 || (_treatments$conv = _treatments$conv.parameters) === null || _treatments$conv === void 0 ? void 0 : _treatments$conv.group;
      setConv0002Variant(group);
    });
  }, []);
  return conv0002Variant;
};